import { isErrorLike } from '@apollo/client/errors';
import { useMutation } from '@apollo/client/react';

import { AgentSendCashbackCardTermsInput } from '@generated/gql/graphql';
import { SnackbarVariant, useSnackbar } from '@hooks/useSnackbar';
import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { YourDetailsFormValues } from '@src/types/yourDetails';

import { agentSendCbcTerms } from '../query';

const useSendCbcTerms = (
  basketId: string,
  formValues: YourDetailsFormValues
) => {
  const [sendTerms, { loading, error }] = useMutation(agentSendCbcTerms);
  const queueSnackbarError = useSnackbarError();
  const snackbar = useSnackbar();

  const input: AgentSendCashbackCardTermsInput = {
    basketId,
    email: formValues.aboutEmail,
    title: formValues.aboutNameTitle,
    firstName: formValues.aboutNameFirst,
    lastName: formValues.aboutNameLast,
  };

  return {
    loading,
    error,
    sendTerms: async () => {
      try {
        await sendTerms({
          variables: {
            input,
          },
          onCompleted: () => {
            snackbar({
              message: 'Terms & Conditions sent',
              variant: SnackbarVariant.Success,
            });
          },
        });
      } catch (error) {
        if (isErrorLike(error)) {
          queueSnackbarError(error);
        }
      }
    },
  };
};

export { useSendCbcTerms };
